import type { LatLng } from '~/_shared/types/latLng';

export const renderExportReportMapCircles = ({ radiusList, mapInstance, center, mapType }: {
  radiusList: ReadonlyArray<number>;
  mapInstance: google.maps.Map;
  center: LatLng;
  mapType: 'roadmap' | 'hybrid';
}) => {
  return radiusList.map((radius) => {
    mapInstance.setOptions({
      center,
      mapTypeId: mapType,
      disableDefaultUI: true,
      gestureHandling: 'none',
      clickableIcons: false,
    });

    const circle = new google.maps.Circle({
      map: mapInstance,
      center,
      radius,
      fillColor: '#0078CE',
      fillOpacity: 0.5,
      strokeColor: '#0078CE',
      strokeOpacity: 1,
      strokeWeight: 2,
      clickable: false,
    });

    const circleBounds = circle.getBounds();

    if (circleBounds) {
      mapInstance.fitBounds(circleBounds);
    }

    return circle;
  });
};
